/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import {
  NOTIFICATION_READ_FETCH_SUCCESS,
  NOTIFICATION_READ_REFRESH_SUCCESS,
  NOTIFICATION_READ_LOAD_MORE_SUCCESS,
  NOTIFICATION_UNREAD_FETCH_SUCCESS,
  NOTIFICATION_UNREAD_REFRESH_SUCCESS,
  NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS,
} from '../Notifications/actions';
import { FETCH_NOTIFICATION_DETAIL_SUCCESS } from '../PushNotification/actions';
import { LOGOUT_SUCCESS } from '../Auth/actions';
import { FETCH_USER_ISSUED_BADGES_FOR_COURSE_SUCCESS } from './actions';

const INITIAL_STATE = Immutable.fromJS({
  byId: {},
  byUserCohort: {
    /*
    [userId]: {
      [cohortPath]: [ids...]
    }
    */
  },
});

const setBadges = (badges, state) => {
  let updatedState = state;
  for (const badge of badges.values()) {
    updatedState = updatedState.setIn(['byId', badge.get('id')], badge);
  }
  return updatedState;
};

export function IssuedBadges(state = INITIAL_STATE, action) {
  switch (action.type) {
    case NOTIFICATION_READ_FETCH_SUCCESS:
    case NOTIFICATION_READ_REFRESH_SUCCESS:
    case NOTIFICATION_READ_LOAD_MORE_SUCCESS:
    case NOTIFICATION_UNREAD_FETCH_SUCCESS:
    case NOTIFICATION_UNREAD_REFRESH_SUCCESS:
    case NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS:
    case FETCH_NOTIFICATION_DETAIL_SUCCESS: {
      const badges = Immutable.fromJS(action.badges);
      return setBadges(badges, state);
    }
    case FETCH_USER_ISSUED_BADGES_FOR_COURSE_SUCCESS: {
      const { userId, cohortPath, issuedBadges } = action;
      const badges = Immutable.fromJS(issuedBadges);
      const badgeIds = badges.map((badge) => badge.get('id')).toList();
      let updatedState = setBadges(badges, state);
      updatedState = updatedState.setIn(
        ['byUserCohort', userId, cohortPath],
        badgeIds
      );
      return updatedState;
    }
    case LOGOUT_SUCCESS: {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
}
